import { TRANSLATIONS } from './translations';
import { HeavyDutyMachineryOption } from './heavyDutyMachinerySpaceOptions';

export const HOST_ACCOUNT_TYPE_OPTIONS: HeavyDutyMachineryOption[] = [
  { value: 'Individual', labelKey: TRANSLATIONS.HOST_OPT_ACCOUNT_TYPE_INDIVIDUAL },
  { value: 'Business', labelKey: TRANSLATIONS.HOST_OPT_ACCOUNT_TYPE_BUSINESS },
];

// Describes the TYPE OF BUSINESS the host runs -- deliberately not the type
// of machine or the kind of work it does, which is Machinery's own concern
// (its Category/Setting fields), never duplicated here. Drives the MCC this
// host's Stripe Connect account is opened with (see StripeConnectService's
// BusinessCategoryToMcc), so these values are what the card networks are
// told the business does -- not just a label on a form.
export const HOST_BUSINESS_CATEGORY_OPTIONS: HeavyDutyMachineryOption[] = [
  { value: 'MachineryRentalCompany', labelKey: TRANSLATIONS.HOST_OPT_BUSINESS_CATEGORY_MACHINERY_RENTAL },
  { value: 'ConstructionCompany', labelKey: TRANSLATIONS.HOST_OPT_BUSINESS_CATEGORY_CONSTRUCTION },
  { value: 'PublicWorksContractor', labelKey: TRANSLATIONS.HOST_OPT_BUSINESS_CATEGORY_PUBLIC_WORKS },
  { value: 'AgricultureForestry', labelKey: TRANSLATIONS.HOST_OPT_BUSINESS_CATEGORY_AGRICULTURE_FORESTRY },
  { value: 'LandscapingGardening', labelKey: TRANSLATIONS.HOST_OPT_BUSINESS_CATEGORY_LANDSCAPING },
  { value: 'DemolitionRecycling', labelKey: TRANSLATIONS.HOST_OPT_BUSINESS_CATEGORY_DEMOLITION_RECYCLING },
  { value: 'MiningQuarrying', labelKey: TRANSLATIONS.HOST_OPT_BUSINESS_CATEGORY_MINING_QUARRYING },
  { value: 'TransportLogistics', labelKey: TRANSLATIONS.HOST_OPT_BUSINESS_CATEGORY_TRANSPORT_LOGISTICS },
  { value: 'IndustrialMaintenance', labelKey: TRANSLATIONS.HOST_OPT_BUSINESS_CATEGORY_INDUSTRIAL_MAINTENANCE },
  { value: 'Other', labelKey: TRANSLATIONS.HOST_OPT_BUSINESS_CATEGORY_OTHER },
];

// A modest curated set (this platform's current markets, same convention as
// HeavyDutyMachineryController's ValidTimezones) rather than every ISO language.
export const HOST_LANGUAGE_OPTIONS: HeavyDutyMachineryOption[] = [
  { value: 'Spanish', labelKey: TRANSLATIONS.HOST_OPT_LANGUAGE_SPANISH },
  { value: 'English', labelKey: TRANSLATIONS.HOST_OPT_LANGUAGE_ENGLISH },
  { value: 'French', labelKey: TRANSLATIONS.HOST_OPT_LANGUAGE_FRENCH },
  { value: 'German', labelKey: TRANSLATIONS.HOST_OPT_LANGUAGE_GERMAN },
  { value: 'Italian', labelKey: TRANSLATIONS.HOST_OPT_LANGUAGE_ITALIAN },
  { value: 'Portuguese', labelKey: TRANSLATIONS.HOST_OPT_LANGUAGE_PORTUGUESE },
  { value: 'Catalan', labelKey: TRANSLATIONS.HOST_OPT_LANGUAGE_CATALAN },
  { value: 'Basque', labelKey: TRANSLATIONS.HOST_OPT_LANGUAGE_BASQUE },
  { value: 'Galician', labelKey: TRANSLATIONS.HOST_OPT_LANGUAGE_GALICIAN },
  { value: 'Dutch', labelKey: TRANSLATIONS.HOST_OPT_LANGUAGE_DUTCH },
  { value: 'Arabic', labelKey: TRANSLATIONS.HOST_OPT_LANGUAGE_ARABIC },
  { value: 'Chinese', labelKey: TRANSLATIONS.HOST_OPT_LANGUAGE_CHINESE },
  { value: 'Japanese', labelKey: TRANSLATIONS.HOST_OPT_LANGUAGE_JAPANESE },
  { value: 'Russian', labelKey: TRANSLATIONS.HOST_OPT_LANGUAGE_RUSSIAN },
  { value: 'Polish', labelKey: TRANSLATIONS.HOST_OPT_LANGUAGE_POLISH },
  { value: 'Swedish', labelKey: TRANSLATIONS.HOST_OPT_LANGUAGE_SWEDISH },
  { value: 'Ukrainian', labelKey: TRANSLATIONS.HOST_OPT_LANGUAGE_UKRAINIAN },
  { value: 'Slovak', labelKey: TRANSLATIONS.HOST_OPT_LANGUAGE_SLOVAK },
];
